import { render, staticRenderFns } from "./ExistingPropertyOwnership.vue?vue&type=template&id=786516b0"
import script from "./ExistingPropertyOwnership.vue?vue&type=script&lang=js"
export * from "./ExistingPropertyOwnership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports